import { SizeClass } from "./SizeClass";

export const useSizeClass = (includeWide?: boolean) => {
  return {
    width: SizeClass.WIDE,
    height: SizeClass.REGULAR,
  };
};
